<template>
  <BaseModal
    name="AddCertificate"
    width="420"
    height="auto"
    :clickToClose="false"
    :shiftY="0.5"
    :adaptive="true"
    classes="!tw-bg-transparent !tw-shadow-none !tw-overflow-visible"
    @before-open="openedModal"
  >
    <div
      class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
    >
      <BaseLoader
        v-if="loading"
        style="z-index: 100"
        class="tw-rounded-[25px]"
      ></BaseLoader>

      <button
        type="button"
        class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
        @click="$modal.hide('AddCertificate')"
      ></button>

      <div class="tw-text-center">
        <div class="tw-text-[23px] tw-mb-[15px]">
          <span v-if="edit"> Редактирование сертификата </span>
          <span v-else> Добавить сертификат </span>
        </div>

        <BaseInputNew
          inputClass="tw-app-input-type-2"
          class="tw-mb-[6px]"
          width="222"
          :value="modalData.fio"
          @input="modalData.fio = $event.value"
          name-sign="ФИО"
        />
        <BaseInputNew
          inputClass="tw-app-input-type-2"
          class="tw-mb-[6px]"
          width="222"
          :value="modalData.passport"
          @input="modalData.passport = $event.value"
          name-sign="Паспорт"
        />

        <div
          class="d-flex align-items-center justify-content-between tw-mb-[6px]"
          ref="vehicles__color"
        >
          <span class="tw-app-input-container-label-type-2">
            Уровень экспертизы
          </span>
          <div class="multiselect-type-2">
            <BaseSelect
              style="width: 220px"
              placeholder=""
              selectLabel=""
              deselectLabel=""
              label="label"
              v-model="modalData.level"
              :options="levelOptions"
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template
              ><template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
          </div>
        </div>

        <div
          class="d-flex align-items-center justify-content-between tw-mb-[6px]"
          ref="vehicles__color"
        >
          <span class="tw-app-input-container-label-type-2">Срок действия</span>
          <div class="multiselect-type-2">
            <BaseSelect
              style="width: 220px"
              placeholder=""
              selectLabel=""
              deselectLabel=""
              label="label"
              v-model="modalData.days"
              :options="daysOptions"
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template
              ><template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
          </div>
        </div>

        <div
          v-if="errors && errors?.length != 0"
          class="tw-text-[12px] tw-text-danger tw-my-[30px]"
        >
          <div v-for="error in errors">
            <div v-for="message in error">
              {{ message }}
            </div>
          </div>
        </div>

        <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
          <button
            @click="$modal.hide('AddCertificate')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            Отменить
          </button>
          <button
            @click="submit()"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
            :disabled="submitting"
          >
            Выполнить
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import GeneralService from "@/api/GeneralService";

export default {
  components: {},
  props: [
    "modalInfo",
    "edit", // id || null
  ],
  data() {
    return {
      loading: false,
      modalData: {
        fio: null,
        passport: null,
        level: {
          label: "5/10",
          key: 5,
        },
        days: {
          label: 90,
          key: 90,
        },
      },
      submitting: false,
      errors: null,
    };
  },
  methods: {
    openedModal() {
      if (this.edit) {
        this.loading = true;
        GeneralService.get(
          `/super/companies/tab/sertificate/table/${this.modalInfo.id}/${this.edit}`
        )
          .then((data) => {
            let cert = data.data.data;
            this.modalData.fio = cert.employee_sertificates__fio;
            this.modalData.passport = cert.employee_sertificates__passport;

            //определим левел
            this.modalData.level =
              this.levelOptions.find(
                (i) => i.key == cert.employee_sertificates__level
              ) || {};

            // определим days
            const date1 = new Date(cert.employee_sertificates__created_at);
            const date2 = new Date(cert.employee_sertificates__life_to);
            const diffInMs = Math.abs(date1 - date2);
            const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
            this.modalData.days =
              this.daysOptions.find((i) => i.key == diffInDays) || {};
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message, { duration: 5000 });
            this.$modal.hide("AddCertificate");
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.modalData = {
          fio: null,
          passport: null,
          level: {
            label: "5/10",
            key: 5,
          },
          days: {
            label: 90,
            key: 90,
          },
        };
      }
    },
    submit() {
      this.submitting = true;
      if (this.edit) {
        GeneralService.edit(
          `/super/companies/tab/sertificate/table/${this.modalInfo.id}/${this.edit}`,
          {
            ...this.modalData,
            level: this.modalData.level.key,
            days: this.modalData.days.key,
          }
        )
          .then((data) => {
            this.$toast.success(data.data.message);
            this.$modal.hide("AddCertificate");
            this.$emit("update");
            this.errors = null;
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message, { duration: 5000 });
            this.errors = e.response.data.errors;
          })
          .finally(() => {
            this.submitting = false;
          });
      } else {
        GeneralService.editOrCreate(
          `/super/companies/tab/sertificate/table/${this.modalInfo.id}`,
          {
            ...this.modalData,
            level: this.modalData.level.key,
            days: this.modalData.days.key,
          }
        )
          .then((data) => {
            this.$toast.success(data.data.message);
            this.$modal.hide("AddCertificate");
            this.$emit("update");
            this.errors = null;
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message, { duration: 5000 });
            this.errors = e.response.data.errors;
          })
          .finally(() => {
            this.submitting = false;
          });
      }
    },
  },
  computed: {
    levelOptions() {
      return [
        {
          label: "5/10",
          key: 5,
        },
        {
          label: "6/10",
          key: 6,
        },
        {
          label: "7/10",
          key: 7,
        },
        {
          label: "8/10",
          key: 8,
        },
        {
          label: "9/10",
          key: 9,
        },
        {
          label: "10/10",
          key: 10,
        },
      ];
    },
    daysOptions() {
      return [
        {
          label: 90,
          key: 90,
        },
        {
          label: 180,
          key: 180,
        },
        {
          label: 360,
          key: 360,
        },
      ];
    },
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
